import { Check, Close, Info, Edit } from "@mui/icons-material";
import { Box, Typography, TextField, IconButton } from "@mui/material";
import React from "react";

/**
 * CellContent component for rendering individual table cell content
 * Handles both viewing and editing modes for cells
 */
const CellContent = ({
  content,
  rowIndex,
  colIndex,
  editingCell,
  selectedCell,
  editValue,
  setEditValue,
  saveCellEdit,
  cancelCellEdit,
  startCellEdit,
  setCellInfoAnchor,
}) => {
  const isEditing =
    editingCell?.row === rowIndex && editingCell?.col === colIndex;
  const isSelected =
    selectedCell?.row === rowIndex && selectedCell?.col === colIndex;

  if (isEditing) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <TextField
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              saveCellEdit();
            } else if (e.key === "Escape") {
              cancelCellEdit();
            }
          }}
          size={"small"}
          variant={"standard"}
          autoFocus
          sx={{ flex: 1 }}
        />
        <IconButton onClick={saveCellEdit} size={"small"} color={"primary"}>
          <Check fontSize={"small"} />
        </IconButton>
        <IconButton onClick={cancelCellEdit} size={"small"} color={"secondary"}>
          <Close fontSize={"small"} />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        minHeight: "100%",
      }}
    >
      <Typography
        variant={"body2"}
        sx={{
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          minWidth: 0,
        }}
      >
        {content || (rowIndex === 0 ? `Col ${colIndex + 1}` : "")}
      </Typography>
      {isSelected && (
        <Box
          sx={{
            display: "flex",
            gap: 0.5,
            ml: 1,
            flexShrink: 0,
          }}
        >
          <IconButton
            size={"small"}
            onClick={(e) => {
              e.stopPropagation();
              setCellInfoAnchor(e.currentTarget);
            }}
            sx={{
              padding: "2px",
              minWidth: "16px",
              width: "16px",
              height: "16px",
            }}
          >
            <Info sx={{ fontSize: "12px" }} />
          </IconButton>
          <IconButton
            size={"small"}
            onClick={(e) => {
              e.stopPropagation();
              startCellEdit();
            }}
            sx={{
              padding: "2px",
              minWidth: "16px",
              width: "16px",
              height: "16px",
            }}
          >
            <Edit sx={{ fontSize: "12px" }} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default CellContent;
